const BaseURi='http://localhost:3300/api/v1'
//  const BaseURi='https://happychildbackend.onrender.com/api/v1'
export const loginurl=`${BaseURi}/login`
export const register=`${BaseURi}/register`
export const update=`${BaseURi}/update`
export const emailstatus=`${BaseURi}/emailstatus`
export const sendotp=`${BaseURi}/sendotp`
export const verifyotp=`${BaseURi}/verifyotp`
export const userdetails=`${BaseURi}/userdetails`
export const registerchild=`${BaseURi}/childadd`
export const getchilddata=`${BaseURi}/childrecord`
export const getchilddelete=`${BaseURi}/childremove`
export const getchildudate=`${BaseURi}/childupdate`
export const gethour=`${BaseURi}/getavailablehour`
export const book=`${BaseURi}/insertbook`
export const getinvoiceid=`${BaseURi}/getbook`
export const getbookbyparentid=`${BaseURi}/getbookbyparentid`
export const loginadmin=`${BaseURi}/adminlogin`
